import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../config/api';
import LegalDocumentModal from './LegalDocumentModal';

/** Rodapé com © Madri Lab + Termos / Privacidade (conteúdo vindo do Master → Configurações). */
export default function LegalFooter({ copyrightKey = 'profile:footerCopyrightLabs', className = '' }) {
  const { t } = useTranslation(['profile']);
  const [legal, setLegal] = useState({ terms: '', privacy: '' });
  const [open, setOpen] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/public/legal`)
      .then((r) => (r.ok ? r.json() : { terms: '', privacy: '' }))
      .then(setLegal)
      .catch(() => setLegal({ terms: '', privacy: '' }));
  }, []);

  return (
    <>
      <footer className={`flex flex-col items-center justify-between gap-4 border-t border-[#e6e8ea] pt-8 text-sm font-medium text-[#595c5d] dark:border-slate-700 dark:text-slate-500 md:flex-row ${className}`}>
        <p>{t(copyrightKey, { year: new Date().getFullYear() })}</p>
        <div className="flex flex-wrap items-center justify-center gap-6">
          <button
            type="button"
            className="cursor-pointer border-none bg-transparent hover:text-[#0546ed] dark:hover:text-blue-400"
            onClick={() => setOpen('terms')}
          >
            {t('profile:footerTerms')}
          </button>
          <button
            type="button"
            className="cursor-pointer border-none bg-transparent hover:text-[#0546ed] dark:hover:text-blue-400"
            onClick={() => setOpen('privacy')}
          >
            {t('profile:footerPrivacy')}
          </button>
        </div>
      </footer>

      <LegalDocumentModal open={open} onClose={() => setOpen(null)} legal={legal} />
    </>
  );
}
